import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useGetNotificationsOnMount } from '@user/store/notifications/hooks'
import { selectAllNotifications } from '@user/store/notifications/slice'

export const useNotificationDataOnMount = () => {
  const loading = useGetNotificationsOnMount()
  const notifications = useSelector(selectAllNotifications)

  const [customerSigned, internal, autoReminder, payOverTimeCompleted] = useMemo(() => {
    const custSigned = notifications.find(
      (n) => n.receiveAgreementOnEverySignature !== null,
    )

    //Find the notification setting for agreement auto-reminder
    const autoReminder = notifications.find(
      (n) =>
        n.maxReminderFollowups !== null &&
        n.reminderFrequency > 0 &&
        n.reminderFrequencyType !== null,
    )

    //Find the notification setting for Pay Over Time Application Completed
    const payOverTimeCompleted = notifications.find(
      (n) => n.notificationEventName === "Pay Over Time Application Completed",
    )

    const internal = notifications.filter(
      (n) => n.id !== custSigned?.id && n.id !== autoReminder?.id && n.id !== payOverTimeCompleted?.id,
    )

    return [custSigned, internal, autoReminder, payOverTimeCompleted]
  }, [notifications])

  return { loading, customerSigned, internal, autoReminder, payOverTimeCompleted }
}
